import { ArchBaseService } from "@/common/api.service";

const API_BASE = "admin/annual-reviews";

const state = {
  reviews: [],
  summary: {},
  pagination: { page: 1, limit: 20, total_items: 0, total_pages: 0 },
  currentReview: null,
  isLoading: false,
  error: null,
};

const getters = {
  annualReviews: (s) => s.reviews,
  annualReviewSummary: (s) => s.summary,
  annualReviewPagination: (s) => s.pagination,
  currentAnnualReview: (s) => s.currentReview,
  annualReviewLoading: (s) => s.isLoading,
  annualReviewError: (s) => s.error,
};

const mutations = {
  SET_REVIEWS(state, data) {
    state.reviews = data;
  },
  SET_SUMMARY(state, data) {
    state.summary = data;
  },
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_CURRENT_REVIEW(state, data) {
    state.currentReview = data;
  },
  SET_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_ERROR(state, val) {
    state.error = val;
  },
};

const actions = {
  async fetchAnnualReviews({ commit }, params = {}) {
    ArchBaseService.init();
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await ArchBaseService.get(`${API_BASE}/`, params);
      const { reviews, pagination, summary } = response.data.details;
      commit("SET_REVIEWS", reviews || []);
      commit("SET_PAGINATION", pagination || {});
      commit("SET_SUMMARY", summary || {});
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_ERROR", msg);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchAnnualReviewDetail({ commit }, reviewId) {
    ArchBaseService.init();
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await ArchBaseService.get(`${API_BASE}/${reviewId}`);
      commit("SET_CURRENT_REVIEW", response.data.details);
      return response.data.details;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_ERROR", msg);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async decideAnnualReviewSection(
    { commit, state },
    { reviewId, section, action = "approve", admin_comment },
  ) {
    ArchBaseService.init();
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await ArchBaseService.put(
        `${API_BASE}/${reviewId}/sections/approve`,
        { section, action, admin_comment },
      );
      // Refresh detail so badges/status stay in sync
      if (state.currentReview?.id === reviewId) {
        const detail = await ArchBaseService.get(`${API_BASE}/${reviewId}`);
        commit("SET_CURRENT_REVIEW", detail.data.details);
      }
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      commit("SET_ERROR", msg);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  /** @deprecated prefer decideAnnualReviewSection */
  async approveAnnualReviewSection(context, payload) {
    return context.dispatch("decideAnnualReviewSection", {
      ...payload,
      action: payload.action || "approve",
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
